import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { FormContext, useForm } from 'react-hook-form';

import { Button, Popup, RadioInput } from './';

import { popupState, openPopup, closePopup } from '../store/slices/popup'
import helpData from '../constants/help'


/**
* Application header
*/
const Header = () => {
  const { t } = useTranslation('global');
  const { currentPopup } = useSelector(popupState);
  const dispatch = useDispatch();
  const methods = useForm();
  const { REACT_APP_CONTACT_PHONE } = process.env;

  const [helpOption, setHelpOption] = useState({});
  const helpCallback = (name, value) => setHelpOption(value);
  return (
    <FormContext {...methods} >
      <header className='header'>
        <div className='header__container'>
          <img className='header__image' alt={t('slogan')} src='https://agroclimapro.climatempo.com.br/img/logo-branco-climatempo-stormgeo.png' />
          <Button
            type='button'
            text={t('help.button')}
            mode='secondary'
            noMargin={true}
            onClick={() => dispatch(openPopup('help'))}
          />
        </div>
        <Popup
          title={t('help.popup.title')}
          isOpen={currentPopup === 'help'}
          primaryButton={{
            text: t('help.popup.closeButton'),
            type: 'button',
            mode: 'primary',
            onClick: () => dispatch(closePopup())
          }}
          secondaryButton={{
            text: t('help.popup.helpButton'),
            type: 'link',
            mode: 'secondary',
            url: `https://wa.me/55${REACT_APP_CONTACT_PHONE}`
          }}>
          <div>
            <RadioInput name='helpOption'
              defaultValue={helpOption}
              options={{ data: helpData }}
              onSelect={helpCallback}
            />
            <p className='popup__text'>
              {helpOption?.description}
            </p>
          </div>
        </Popup>
      </header>
    </FormContext>
  );
}
export default Header;